import React, { ReactNode } from 'react';
import { t } from '../../../../../utils/helpers';
import { TablePoints } from './tablePoints/tablePoints';
import MainButton from '@ui-kit/components/mainButton';
import { container } from 'tsyringe';
import { IPlayer, IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import { ITable } from '@base/features/game/model/interfaces';
import btn_ladder from '../../../../../assets/images/btn_ladder.svg';
import { TablePlayerCard } from '../tablePlayerCard/tablePlayerCard';
import LobbyService from '@base/features/lobby/model/lobbyService';

export enum JoinTableMode {
  PLAY,
  WATCH,
}

function TablesList(props: { tables: ITable[]; children?: ReactNode }) {
  return (
    <div className="table-list__content">
      {props.tables.map((table) => (
        <RenderTable key={table.tid} table={table} players={table.seats} />
      ))}
    </div>
  );
}

function RenderTable(props: { table: ITable; players: (IPlayer | undefined)[] }) {
  const { table, players } = { ...props };
  // const canWatchTable = BaseTable.canWatchTable(table);
  const halfPoints = table.getMatchString();
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const lobbyService: LobbyService = container.resolve('lobbyService');

  const fullPoints = {
    table: table.getNumber(),
    matchStringLong: table.getMatchStringLong(),
    timePerMoveStringL: table.getTimePerMoveString(0, '/move'),
  };

  const rows = [
    { player: players[0], seat: 'left' },
    { player: players[1], seat: 'right' },
  ];

  if (table.seats.length === 0) {
    return null;
  }

  function joinTable(mode: JoinTableMode) {
    const tid = table.tid;
    mode === JoinTableMode.PLAY ? lobbyService.playTable(tid) : lobbyService.watchTable(tid);
  }

  return (
    <div
      className="table-list__content-item"
      key={`${table.tid}`}
      onClick={() => console.log(playersOnlineRepository.me?.getTable())}
    >
      <div className="table-list__number table-list__content-playing-item">{table.getNumber()}</div>
      {rows.map((row, i) => (
        <PlayerRow
          key={i}
          player={row.player}
          table={table}
          seat={row.seat}
          playTable={() => joinTable(JoinTableMode.PLAY)}
        />
      ))}
      <div className="table-list__watch table-list__content-playing-item">
        {props.table.canBeWatched() && !playersOnlineRepository.me?.getTable() ? (
          <MainButton className="table-list__button-watch" onClick={() => joinTable(JoinTableMode.WATCH)}>
            {t('watch')}
          </MainButton>
        ) : null}
      </div>
      <TablePoints halfPoints={halfPoints} fullPoints={fullPoints} />
      <div className="table-list__ticket-settings table-list__content-playing-item">
        {table.getTicketString()}
      </div>
    </div>
  );
}

function PlayerRow(props: {
  player: IPlayer | undefined;
  table: ITable;
  seat: string;
  playTable?: () => void;
  me?: IPlayer;
}) {
  const { player, table } = { ...props };

  if (player) {
    return <TablePlayerCard player={player} />;
  } else {
    return (
      <div className="table-list-player table-list-player-vs table-list__content-playing-item">
        <div className="table-list__play">
          {props.table.canBePlayed() ? (
            <MainButton className="main-btn_medium main-btn_fixed" onClick={() => props.playTable?.()}>
              <div className="table-list__play-ladder-wrap">
                {t('play')}
                <div>
                  {table.ladder ? (
                    <img className="table-list__play-ladder-img" src={btn_ladder} alt="icon ios" />
                  ) : null}
                </div>
              </div>
            </MainButton>
          ) : (
            t('invite_only')
          )}
        </div>
      </div>
    );
  }
}

export default TablesList;
